<template>
  <div>
    <v-row class="textPanel pb-16 pt-8" :class="classBg" style="margin: auto!important;">
      <div :class="classFootContainer">
        <div class="pl-3 pr-3 pb-0 pt-4">
            <div class="hidden-md-and-down pb-4 mb-0">
              <v-row class="mb-0">
                <v-col cols="4">
                          <v-row justify="center" class="ma-0 pr-4">
                            <LogoBlack @click="handleClickMenu('42Monks')" v-if="this.type === 'finance'" style="min-height: 120px;"></LogoBlack>
                          </v-row>
                            <v-row justify="center" style="padding-bottom:4px;" class="pt-0 mt-0">
                              <span class="font-logos" style="opacity:0.7; font-size: 14px; color: black!important;">PRIVATE WEALTH MANAGEMENT</span>
                            </v-row>
                            <v-row justify="center" style="padding-bottom:4px;" >
                              <span class="font-logos" style="opacity:0.7; font-size: 14px; color: black!important;">42Monks Capital, Monaco</span>
                            </v-row>
                            <v-row justify="center" style="padding-bottom:0px;">
                              <span class="font-logos" style="opacity:0.7; font-size: 14px; color: black!important;">74 Boulevard d'Italie, Monte Carlo 98000</span>
                            </v-row>
                </v-col>
                <v-col cols="3">
                    <v-list :class="[classListMenu, classFootItem]" class="fonts-xsmall2"   density="compact" >
                      <v-list-item :ripple="false" v-for="(item, index) in itemsProjects" :key="index" :value="index" style="cursor:default; padding-right: 0px;" @click.stop="handleClick">
                        <v-list-item-title :class="classListItem" style="font-weight: 500!important;" @click="handleClickMenu(item.link)">{{ item.title }}</v-list-item-title>                       
                      </v-list-item>                     
                    </v-list>
                </v-col>
                <v-col cols="3">
                    <v-list :class="[classListMenu, classFootItem]" class="fonts-xsmall2"   density="compact" >
                      <v-list-item :ripple="false" v-for="(item, index) in itemsCompany" :key="index" :value="index" style="cursor:default; padding-right: 0px;" @click.stop="handleClick">
                        <v-list-item-title v-if="item.v" :class="classListItem" style="font-weight: 500!important;" @click="handleClickMenu(item.link)">{{ item.title }}</v-list-item-title>     
                        <v-list-item-title v-if="!item.v" :class="classListItem" style="font-weight: 500!important;" ><s>{{ item.title }}</s></v-list-item-title>                   
                      </v-list-item>                     
                    </v-list>
                </v-col>
              </v-row>
            </div>

            <div class="hidden-lg-and-up hidden-sm-and-down pb-4 mb-0">
              <v-row class="mb-0 pl-7">
                <v-col cols="5">
                    <v-list :class="[classListMenu, classFootItem]" class="fonts-xsmall2"   density="compact" >
                      <v-list-item :ripple="false" v-for="(item, index) in itemsProjects" :key="index" :value="index" style="cursor:default; padding-right: 0px;" @click.stop="handleClick">
                        <v-list-item-title :class="classListItem" style="font-weight: 500!important;" @click="handleClickMenu(item.link)">{{ item.title }}</v-list-item-title>                       
                      </v-list-item>                     
                    </v-list>
                </v-col>
                <v-col cols="5">
                    <v-list :class="[classListMenu, classFootItem]" class="fonts-xsmall2"   density="compact" >
                      <v-list-item :ripple="false" v-for="(item, index) in itemsCompany" :key="index" :value="index" style="cursor:default; padding-right: 0px;" @click.stop="handleClick">
                        <v-list-item-title v-if="item.v" :class="classListItem" style="font-weight: 500!important;" @click="handleClickMenu(item.link)">{{ item.title }}</v-list-item-title>  
                        <v-list-item-title v-if="!item.v" :class="classListItem" style="font-weight: 500!important;" ><s>{{ item.title }}</s></v-list-item-title>                                        
                      </v-list-item>                     
                    </v-list>
                </v-col>
              </v-row>
            </div>


            <div class="hidden-md-and-up pb-4 mb-0">
              <v-row class="mb-0 pl-7 pb-0">
                <v-col cols="12">
                    <v-list :class="[classListMenu, classFootItem]" class="fonts-xsmall2"   density="compact" >
                      <v-list-item :ripple="false" v-for="(item, index) in itemsProjects" :key="index" :value="index" style="cursor:default; padding-right: 0px;" @click.stop="handleClick">
                        <v-list-item-title :class="classListItem" style="font-weight: 500!important;" @click="handleClickMenu(item.link)">{{ item.title }}</v-list-item-title>                       
                      </v-list-item>                     
                    </v-list>
                </v-col>
              </v-row>
              <v-row class="mb-0 pl-7 pa-0 mt-0 mb-0">

                <v-col cols="12" class="pt-0 mt-0">
                    <v-list :class="[classListMenu, classFootItem]" class="fonts-xsmall2"   density="compact" >
                      <v-list-item :ripple="false" v-for="(item, index) in itemsCompany" :key="index" :value="index" style="cursor:default; padding-right: 0px;" @click.stop="handleClick">
                        <v-list-item-title v-if="item.v" :class="classListItem" style="font-weight: 500!important;" @click="handleClickMenu(item.link)">{{ item.title }}</v-list-item-title>   
                        <v-list-item-title v-if="!item.v" :class="classListItem" style="font-weight: 500!important;" ><s>{{ item.title }}</s></v-list-item-title>                        
                      </v-list-item>                     
                    </v-list>
                </v-col>
              </v-row>
            </div>
            <v-divider :class="classDividers" style="color:black!important"></v-divider>
            <v-divider :class="classDividersXs" style="color:black!important"></v-divider>
            <div class="hidden-xs pb-4">
              <v-row class="mb-0 pl-3">
                <v-col cols="4">
                    <v-list :class="[classListMenu, classFootItem]" class="fonts-xsmall2"  density="compact" >
                      <v-list-item :ripple="false" v-for="(item, index) in itemsFoot" :key="index" :value="index" style="cursor:default; padding-right: 0px;" @click.stop="handleClick">
                        <v-list-item-title :class="classListItem" style="font-weight: 500!important;" @click="handleClickMenu(item.link)">{{ item.title }}</v-list-item-title>                       
                      </v-list-item>                     
                    </v-list>
                </v-col>
                <v-col cols="8">
                  <v-row class="ma-0 pa-0 pt-12" justify="end">
                    <v-btn text plain :ripple="false" elevation="0" :class="classBtnIconFootStyle" @click="scrollToTop" style="color:black!important;">
                      Jump to top
                      <v-icon :class="classIconStyle"> mdi-arrow-up</v-icon>
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </div>
            <div class="hidden-sm-and-up pb-4">
              <v-row class="mb-0 pl-3 pb-0 mb-0">
                <v-col cols="12">
                    <v-list :class="[classListMenu, classFootItem]" class="fonts-xsmall2"   density="compact" >
                      <v-list-item :ripple="false" v-for="(item, index) in itemsFoot" :key="index" :value="index" style="cursor:default; padding-right: 0px;" @click.stop="handleClick">
                        <v-list-item-title :class="classListItem" style="font-weight: 500!important;" @click="handleClickMenu(item.link)">{{ item.title }}</v-list-item-title>                       
                      </v-list-item>                     
                    </v-list>
                </v-col>
              </v-row>
              <v-row class="ma-0 pa-0 pt-4" justify="center">
                    <v-btn text plain :ripple="false" elevation="0" :class="classBtnIconFootStyle" style="color:black!important;" @click="scrollToTop">
                      Jump to top
                      <v-icon :class="classIconStyle"> mdi-arrow-up</v-icon>
                    </v-btn>
              </v-row>
            </div>
          </div>
      </div>
    </v-row>
  </div>
</template>
<script>
import LogoBlack from '@/components/logo_black.vue'

export default {
  name: 'Footer',
  props: ['typed'],
  components: {
    LogoBlack
  },

  data: () => ({
    scrollPosition: 0,
    type: 'standard',
    classBg: { 'bg_scroll_color': true },
    classListMenu: { 'bg_scroll_listmenu': true },
    itemsProjects: [
        { title: 'Family Office', link: 'FamilyOffice', icon: '' },
        { title: 'Generational Wealth Management', link: 'FortyTwo', icon: ''},
        { title: 'Quantitative Trading', link: 'Quant', icon: ''}      
      ],
    itemsCompany: [
        { title: 'About', link: 'About' , icon: '', v: true},
        { title: 'Contact', link: 'Contact', icon: '', v: true }
      ],
    itemsFoot: [
        { title: 'Privacy Policy', link: 'Privacy' , icon: ''},
        { title: 'Terms & Conditions', link: 'Terms', icon: '' }
    ],
  }),
  beforeMount() {
    this.type = this.typed;
  },
  mounted() {
        this.classBg = {
          'bg_scroll_color_finance': this.type === 'finance',
        };
        this.classListMenu = {
          'bg_std_listmenu_finance': this.type === 'finance',
        }
  },
  computed: {
    classListItem() {
      return this.generateListItemClass('listmenuitem', this.type, 'bg_std_');
    },
    classIconStyleHover() {
    return this.getStyleClasses('mdi-18px icon-hover', 'icon-style', this.type);
    },
    classIconStyle() {
      return this.getStyleClasses('mdi-18px', 'icon-style', this.type);
    },
    classBtnIconStyle() {
      return this.getStyleClasses('text-none', 'menu-btn-icon', this.type);
    },
    classBtnIconFootStyle() {
      return this.getStyleClasses('text-none', 'menu-btn-icon-foot', this.type);
    },
    classBtnIconBorderStyle() {
      return this.getStyleClasses('text-none', 'menu-btn-icon-border', this.type);
    },
    classIconMenu() {
      return this.getStyleClasses('', 'icon-menu', this.type);
    },
    classIconStyleMenu() {
      return this.getStyleClasses('mdi-18px', 'icon-menu-drop', this.type);
    },
    classMenuButton() {
      return this.getStyleClasses('text-none', 'menu-btn', this.type);
    },
    classMenuButtonShort() {
      return this.getStyleClasses('text-none', 'menu-btns', this.type);
    },
    classNoMenuButton() {
      return this.getStyleClasses('text-none', 'nomenu-btn', this.type);
    },
    classFootItem() {
      return this.getStyleClasses('', 'foot-item-color', this.type);
    },  
    classFootContainer() {
      return this.getStyleClasses('', 'full-cont', this.type);
    },
    classDividers() {
      return this.getStyleClasses('ml-6 mr-6 hidden-xs', 'foot-divider', this.type);
    },
    classDividersXs() {
      return this.getStyleClasses('ml-6 mr-6 hidden-sm-and-up', 'foot-dividerxs', this.type);
    },
  },
  watch: {
  },
  created() {

  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    generateListItemClass(classSuffix, styleT, prefix = 'bg_scroll_') {
      return {
        [`${prefix}${classSuffix}`]: styleT === 'standard',
        [`${prefix}${classSuffix}_${styleT}`]: styleT !== 'standard',
      };
    },
    getStyleClasses(primaryClass, secondaryClass, styleT) {
      return {
        [primaryClass]: true,
        [`${secondaryClass}_${styleT}`]: styleT !== 'standard',
        [`${secondaryClass}`]: styleT === 'standard',
      };
    },
    gotoroot() {
      if (this.$route.name != '42Monks') {
        this.$router.push({ name: '42Monks' });
      }
    },
    handleClick(){
      // Nothing..
    },
    handleClickMenu(link){
      if (link === 'Office'){
        window.open('https://office.42monks.com/','_blank');
      } else if (link === 'Log') {
        window.open('https://selene.42monks.com/','_blank');
      } else {
        if (this.$route.name !== link ) {
          this.$router.push({ name: link });
        }
      }
    },

  }
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';
@use './css/styles_finance.scss';

.container-size {
  padding-right: 24px;
  padding-left: 24px;

  @media (min-width: 960px) {
    max-width: 1608px;
  }
}

:deep(.v-btn:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true])>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item:hover)>.v-list-item__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item__append){
  display: inline-block;
}

:deep(.v-list-item--active > .v-list-item__overlay), 
:deep(.v-list-item[aria-haspopup=menu][aria-expanded=true] > .v-list-item__overlay) {
  opacity: 0;
}



</style>
